import "../../widgets/notaires/_notaires";
import AOS from "aos";

window.addEventListener("DOMContentLoaded", () => {
	AOS.init({
		duration: 1000,
		mirror: false,
		once: true,
	});

	const initMobileMenu = () => {
		let burger = document.querySelector("#header .burger");
		let mobile_menu = document.querySelector("#header .nav_mobile");
		console.log("coucou");
		if (burger && mobile_menu) {
			burger.addEventListener("click", () => {
				mobile_menu.classList.toggle("visible");
			});
		}
	};

	initMobileMenu();
});
